/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { lazy, useEffect } from "react";
import { Row, Col } from "antd";
import Zoom from "react-reveal/Zoom";
import { withTranslation } from "react-i18next";
import {FBGridV, FBItemV} from 'react-flexbox-grid-rs';
import {useViewport} from 'react-viewport-provider';

import useForm from "./useForm";
import validate from "./validationRules";

import * as S from "./styles";
import {Block} from "../Block";
import {Input} from "../Input";
import {Button} from "../Button";
import {TextArea} from "../TextArea";

export const Contact = ({
    title,
    content,
    id,
    url,
    subject,
    appId,
    action,
    color,
    secondaryColor,
    onFocusColor
}) => {
    const {
        values,
        errors,
        handleChange,
        handleSubmit,
        shouldSubmit,
        spinner
    } = useForm(validate, url, subject, appId, action);
    const {bp} = useViewport();
    useEffect(() => {
        if (shouldSubmit) {
            document.getElementById("contactform").reset();
        }
    }, [shouldSubmit]);

    const ValidationType = ({ type }) => {
        const ErrorMessage = errors[type];
        return errors[type] ? (
            <Zoom cascade>
                <S.Span>{ErrorMessage}</S.Span>
            </Zoom>
        ) : (
            <S.Span />
        );
    };

    const _getContactForm = () => {
        return (
            <FBItemV colspan={bp==='xs' ? 20:10}>
                <S.FormGroup
                    autoComplete="off"
                    id="contactform"
                    onSubmit={handleSubmit}
                >
                    <Col span={24}>
                        <Input
                            type="text"
                            name="name"
                            id="Name"
                            placeholder="Your Name"
                            value={values.name || ""}
                            onChange={handleChange}
                        />
                        <ValidationType type="name" />
                    </Col>
                    <Col span={24}>
                        <Input
                            type="text"
                            name="email"
                            id="Email"
                            placeholder="Your Email"
                            value={values.email || ""}
                            onChange={handleChange}
                        />
                        <ValidationType type="email" />
                    </Col>
                    <Col span={24}>
                        <TextArea
                            placeholder="Your Message"
                            value={values.message || ""}
                            name="message"
                            id="Message"
                            onChange={handleChange}
                            maxlength={300}
                        />
                        <ValidationType type="message" />
                    </Col>
                    <S.ButtonContainer>
                        <Button
                            name="submit"
                            type="submit"
                            color={color}
                            secondaryColor={secondaryColor}
                            onFocusColor={onFocusColor}
                            onLoading={spinner}
                        >
                            {spinner === true ? ("Submitting..") : ("Submit")}
                        </Button>
                    </S.ButtonContainer>
                </S.FormGroup>
            </FBItemV>
        );
    };

    return (
        <S.ContactContainer id={id}>
            <S.Contact>
                <FBGridV type="flex" justify="space-around" align="middle">
                    <FBItemV colspan={bp==='xs' ? 20:10}>
                        <Block padding={true} title={title} content={content} />
                    </FBItemV>
                    {_getContactForm()}
                </FBGridV>
            </S.Contact>
        </S.ContactContainer>
    );
};
